export default __webpack_public_path__ + "static/media/126.cc3dbe09.jpg";